import { takeLatest, put, call, cancelled } from 'redux-saga/effects';
import instance from '../../../../services/request';
import { REPORT_REQUEST, reportSuccess, reportFail } from '../actions/reports';
import { GET_REPORT_REQUEST, getReportFail, getReportSuccess } from '../actions/generateReport';
import { getReport, getGenerateFile } from '../../services/reports';
import { openNotification } from 'common/misc/openNotification';

function* workReportRequest(action) {
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();

  try {
    const { payload } = action;

    const { sourceId, onSuccess, params, fileConfig } = payload;
    let requestConfig;
    let service;
    let response;

    if (sourceId === 'DevReports') {
      response = yield getGenerateFile({ data: params, cancelToken: source.token });
    } else {
      service = getReport;
      requestConfig = { sourceId, params, cancelToken: source.token };
      response = yield call(service, requestConfig);
    }

    if (response) {
      if (response.Blob === null) {
        openNotification(
          'error',
          response.Message
            ? response.Message
            : 'El sistema no pudo realizar la operación, inténtelo de nuevo mas tarde'
        );
      }

      if (typeof response !== 'undefined') {
        if (onSuccess) onSuccess();
        yield put(reportSuccess());
        yield put(getReportSuccess());
        let blob = '';
        if (sourceId === 'DevReports') {
          if (response) {
            blob = response.data;
            const link = document.createElement('a');
            link.href = `data:application/pdf;base64,${blob}`;
            link.download = `${params.name}.${fileConfig ? fileConfig.extension : 'xlsx'}`;
            link.click();
          }
        } else {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.download = `${params.name}.${fileConfig ? fileConfig.extension : 'xlsx'}`;
          link.click();
        }

        return response;
      }
    } else {
      yield put(getReportFail());
      yield put(reportFail());
    }
  } catch (error) {
    yield put(getReportFail());
    console.error('[Redux-Saga-Basf]', error);
    yield put(reportFail());
  } finally {
    if (yield cancelled()) {
      source.cancel('cancelled RQUEST');
    }
  }
}

export function* watchReportRequest() {
  yield takeLatest(REPORT_REQUEST, workReportRequest);
}

export function* watchReportsGetRequest() {
  yield takeLatest(GET_REPORT_REQUEST, workReportRequest);
}
